import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.lean-planning')
  .factory('$routesPageable', routesPageableObjectFactory);

/* @ngInject */
function routesPageableObjectFactory($bringozFactory: $bringozFactory,
                                     RoutesPageableAPI: BringozApi,
                                     Routes_Pageable_DS: DataStoreConfig) {

  function $routesPageable(id: string) {
    return $bringozFactory(id, RoutesPageableAPI, Routes_Pageable_DS);
  }

  return $routesPageable;
}
